import React, { Component } from 'react';

class PassportClient extends Component {

    constructor() {

        super();
        this.onRemove = this.onRemove.bind(this);
    }

    onRemove() {

        return this.props.onRemove(this.props.client);
    }

    render() {

        return (
            <li className="list-group-item">
                <div className="row">
                    <div className="col-6">
                        {this.props.client}
                    </div>
                    <div className="col-6 text-right">
                        <span style={{ cursor: 'pointer' }} onClick={this.onRemove}>
                            <i className="fa fa-times"></i>
                        </span>
                    </div>
                </div>
            </li>
        );
    }
}

class PassportClientsPanel extends Component {

    constructor() {

        super();
        this.state = {
            newPassportClient: ''
        };
        this.onNewPassportClientKeyed = this.onNewPassportClientKeyed.bind(this);
        this.onNewPassportClientPossiblySubmitted = this.onNewPassportClientPossiblySubmitted.bind(this);
    }

    onNewPassportClientKeyed(e) {

        this.setState({ newPassportClient: e.target.value });
    }

    onNewPassportClientPossiblySubmitted(e) {

        if (e.key === 'Enter') {
            this.props.onAdd(this.state.newPassportClient.slice());
            this.setState({ newPassportClient: '' });
        }
    }

    render() {

        const title = this.props.title ?
            (<span className="text-center"><strong>{this.props.title}</strong></span>) :
            null;

        return (
            <div className="row">
                <div className="col-12">
                    {title}
                    <div className="row">
                        <div className="col-12">
                            <ul className="list-group">
                                {
                                    this.props.clients && this.props.clients.map((c, index) => {

                                        console.log(c)

                                        return <PassportClient key={c + index.toString()} client={c} onRemove={this.props.onRemove} />
                                    })
                                }
                                <li className="list-group-item">
                                    <style dangerouslySetInnerHTML={{
                                        __html: `
                                        .no-lines:focus {
                                            outline: none;
                                            border-color: inherit;
                                            -webkit-box-shadow: none;
                                            box-shadow: none;
                                        }
                                    `}}>
                                    </style>
                                    <input type="text"
                                        value={this.state.newPassportClient}
                                        className="form-control no-lines"
                                        style={{ border: 'none' }}
                                        placeholder={this.props.placeholder}
                                        onChange={this.onNewPassportClientKeyed}
                                        onKeyPress={this.onNewPassportClientPossiblySubmitted}
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="col-6">
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PassportClientsPanel;
